import {provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import {ENVIRONMENT_INITIALIZER, EnvironmentProviders, inject, Provider} from '@angular/core';
import {authInterceptor} from 'app/core/auth/auth.interceptor';
import {AuthService} from 'app/core/auth/auth.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> =>
{
    return [
        provideHttpClient(
            withInterceptors([authInterceptor]),
            withInterceptorsFromDi()
        ),
        {
            provide : ENVIRONMENT_INITIALIZER,
            useValue: () => inject(AuthService),
            multi   : true,
        },
    ];
};
